import MemosList from './MemosList';

export default function Memos() {
  return (
      <MemosList />
  );
}
